import './Surveys.css';

import {CustomMetaHelmet} from "../components/CustomMetaHelmet";
import {meta} from "../assets/meta/meta";
import NavLight from "../components/NavLight";
import {Link} from "react-router-dom";
import SurveysEnveded from "../components/surveys/SurveysEnveded/SurveysEnveded";
import React from "react";
import SurveysFeatureList from "../components/surveys/SurveysFeatureList/SurveysFeatureList";
import SurveysDiscover from "../components/surveys/SurveysDiscover/SurveysDiscover";
import FaqQuestions from "../components/surveys/FaqQuestions/FaqQuestions";


function Surveys() {

    return (
        <div className="Surveys">
            <CustomMetaHelmet meta={meta.surveys}/>
            <NavLight/>
            <section className="survey-container">
                <div className="survey-content">
                    <h1>
                        Introducing Magic AI Surveys
                    </h1>
                    <p>
                        Collect deeper and more actionable insights at scale with AI surveys
                    </p>

                    <div className="survey-btn-box">
                        <a href="#survey-enveded-container" style={{textDecoration: "none"}}>
                            <div className="survey-btn-container-outline">
                                <span>Try Magic AI Survey</span>
                            </div>
                        </a>
                        <a href="/schedule-demo" style={{textDecoration: "none"}}>
                            <div className="survey-btn-container">
                                <span>Book a demo</span>
                            </div>
                        </a>
                    </div>
                </div>
                <SurveysEnveded/>
                <SurveysFeatureList/>
                <SurveysDiscover/>
                <FaqQuestions/>
            </section>
        </div>
    )
}

export default Surveys;
